module.exports = __webpack_public_path__ + "ecd370409f460b9835ad1f15ca490a38.MP3";